import classNames from 'classnames';
import React, { useState } from 'react';
import useAppSelector, { useAppDispatch } from '../../app/redux/useAppSelector';
import { skinToneModifiers } from '../../utils/emoji';
import * as styles from './SkinToneSelector.module.scss';
import { UIActions } from '../../ui/uiSlice';

const getClassName = (modifier: string | null) => {
  const index = modifier ? skinToneModifiers.indexOf(modifier) : -1;
  return `tone${index === -1 ? 0 : index + 1}`;
};

interface SkinToneSelectorProps {
  initialOpen?: boolean;
}

const SkinToneSelector = ({ initialOpen }: SkinToneSelectorProps) => {
  const dispatch = useAppDispatch();
  const modifier = useAppSelector((state) => state.ui.emojiSkinToneModifier);

  const [isOpen, setIsOpen] = useState(initialOpen);

  return isOpen ? (
    <div className={styles.selector}>
      <div className={styles.title}>Choose tone</div>
      {[null, ...skinToneModifiers].map((value) => (
        <div
          key={value}
          className={classNames(styles.skinToneContainer, {
            [styles.selected]: value === modifier,
          })}
          onClick={() => {
            dispatch(UIActions.changeEmojiSkinToneModifier(value));
            setIsOpen(false);
          }}
        >
          <div
            className={classNames(styles.skinTone, styles[getClassName(value)])}
          />
        </div>
      ))}
    </div>
  ) : (
    <div className={styles.container} onClick={() => setIsOpen(true)}>
      <div className={styles.title}>Skin tone:</div>
      <div
        className={classNames(styles.skinTone, styles[getClassName(modifier)])}
      />
    </div>
  );
};

export default SkinToneSelector;
